import { sectionsCourses } from 'modules/courses/constants'
import {
  CourseSectionsEnum,
  CourseSectionsTitleEnum,
} from 'modules/courses/enums/course-sections-enum'
import { useRouter } from 'next/router'
import React from 'react'
import { PageTab } from 'shared/components/page-tab/page-tab'
import { PageTabGroup } from 'shared/components/page-tab/page-tab-group'
import { PageTabList } from 'shared/components/page-tab/page-tab-list'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twJoin } from 'tailwind-merge'

const TabMenu = ({ showAssigments }: { showAssigments?: boolean }) => {
  const { t } = useLocoTranslation()
  const router = useRouter()
  const section = router.route

  return (
    <PageTabGroup
      className="mt-[-20px]"
      selectedIndex={sectionsCourses.findIndex(el => el === section)}
    >
      <PageTabList>
        <PageTab onClick={() => router.push(CourseSectionsEnum.courses)}>
          {t(`${CourseSectionsTitleEnum.courses}`)}
        </PageTab>

        <PageTab onClick={() => router.push(CourseSectionsEnum.bundles)}>
          {t(`${CourseSectionsTitleEnum.bundles}`)}
        </PageTab>

        <PageTab onClick={() => router.push(CourseSectionsEnum.students)}>
          {t(`${CourseSectionsTitleEnum.students}`)}
        </PageTab>
        <PageTab
          className={twJoin(!showAssigments && 'hidden')}
          onClick={() => router.push(CourseSectionsEnum.assignments)}
        >
          {t(`${CourseSectionsTitleEnum.assignments}`)}
        </PageTab>
      </PageTabList>
    </PageTabGroup>
  )
}

export default TabMenu
